import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useMarketsDescriptionsQuery } from '~shared/hooks/react-query/useMarketsDescriptions';
import MessageButtonCard from '~spa/Components/MessageButtonCard';
import { useMarketIdsForEvent } from '~SpectateStore/hooks/marketsHooks';
import {
    useCashoutAvailable,
    useMarketsGroupsByEventId,
 } from '~SpectateStore/hooks/eventsHooks';
import { useSportSlugByEventId } from '~SpectateStore/hooks/sportsHooks';
import MarketCard from './MarketCard';
import './styles/markets.scss';

const DEFAULT_EXPANDED_MARKETS = 3;

const MarketsSection = ({ eventId }) => {
    const [ t ] = useTranslation();
    const marketIds = useMarketIdsForEvent(eventId);
    const marketGroups = useMarketsGroupsByEventId(eventId);
    const isCashoutAvailable = useCashoutAvailable(eventId);
    const sportSlug = useSportSlugByEventId(eventId);
    const {
        data: marketsDescriptions,
    } = useMarketsDescriptionsQuery(sportSlug);

    const marketsSectionWithMargin = classNames({
        'markets-section--margin' : !isCashoutAvailable,
    });

    if (marketGroups.length > 1 && marketIds.length < 1) {
        return <MessageButtonCard
            message={t('sport_event.no_markets')}
            MessageIconClassName={'no-results'}
        />;
    }

    return (
        <div className={marketsSectionWithMargin}>
        {
            isCashoutAvailable
            ? <div className="markets-section__has-cashout">
                <span className="markets-section__has-cashout--icon"></span>
                {t('banners.cashout_available')}
            </div>
            : null
        }
        {
            marketIds.map((marketId, i) =>
                <MarketCard
                    key={`event-market-${marketId}`}
                    eventId={eventId}
                    marketId={marketId}
                    expand={i < DEFAULT_EXPANDED_MARKETS}
                    marketDescription={marketsDescriptions ? marketsDescriptions[marketId] : ''}
                />
            )
        }
        </div>
    );
};

MarketsSection.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
};

export default MarketsSection;
